export default __webpack_public_path__ + "static/media/88.f24b29ed.jpg";